import { RouterLink } from '@angular/router';
import { Component, Input } from '@angular/core';
import { CurrencyPipe, NgIf } from '@angular/common';

import { MomentModule } from 'ngx-moment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { PaymentsEntity } from '@qwyk/shared-stores/payments';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'li[qwyk-payments-list-view-item]',
    templateUrl: './payments-list-view-item.component.html',
    styleUrls: ['./payments-list-view-item.component.scss'],
    standalone: true,
    imports: [NgIf, RouterLink, CurrencyPipe, MomentModule, FontAwesomeModule]
})
export class PaymentsListViewItemComponent {
    @Input() payment: PaymentsEntity | undefined;
    @Input() embedded = false;
    @Input() withInvoiceDetails = false;
}
